import { Pipe, PipeTransform, inject } from '@angular/core';
import { WarehouseProductType } from '../enums/warehouse-product-type';
import { WarehouseProductTypeProviderService } from '../providers/warehouse-product-type-provider.service';
import { Observable } from 'rxjs';

@Pipe({
  name: 'warehouseProductType',
  standalone: true,
})
export class WarehouseProductTypePipe implements PipeTransform {
  private readonly provider = inject(WarehouseProductTypeProviderService);

  public transform(type: WarehouseProductType): Observable<string> {
    return this.provider.label(type);
  }
}
